/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */

import { Paper, Typography } from "@material-ui/core";
import AmenitiesCard from "../../cards/AmenitiesCard";
import Skeleton from "@material-ui/lab/Skeleton";

/* Define all styles */

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "1.5rem",
    marginBottom: "2rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%",
  },
  heading: {
    color: "#202020",
    fontWeight: "400",
    fontSize: "1.5rem",
    lineHeight: "2.25rem",
    marginBottom: "1rem",
  },
  cardsHolder: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "space-between",
    },
    flexWrap: "wrap",
    gap: "1rem",
  },
  skeletonContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "100%",
  },
  chipSkeleton: {
    width: "20%",
    height: "10rem",
    margin: "1rem 0.5rem 1rem 0rem",
    "&.MuiSkeleton-text": {
      transform: "none",
    },
  },
}));

const Amenities = (props) => {
  const classes = useStyles();

  if (!props.loading) {
    return (
      <React.Fragment>
        <Paper id="amenities" elevation={2} className={classes.paper}>
          <Typography variant="body2" component="p" className={classes.heading}>
            Amenities
          </Typography>
          <div className={classes.cardsHolder}>
            {props.amenities
              ? props.amenities.map((amenity, key) => (
                  <AmenitiesCard
                    title={amenity.label}
                    icon={amenity.icon}
                    key={key}
                  />
                ))
              : "Unable to fetch data :("}
          </div>
        </Paper>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <Paper elevation={2} className={classes.paper}>
          <Skeleton>
            <Typography
              variant="body2"
              component="p"
              className={classes.heading}
            >
              Amenities
            </Typography>
          </Skeleton>
          <div className={classes.skeletonContainer}>
            <Skeleton className={classes.chipSkeleton} />
            <Skeleton className={classes.chipSkeleton} />
            <Skeleton className={classes.chipSkeleton} />
            <Skeleton className={classes.chipSkeleton} />
          </div>
        </Paper>
      </React.Fragment>
    );
  }
};

export default Amenities;
